import styled from 'styled-components/macro'
import { UnControlled as CodeMirror } from 'react-codemirror2'
import { transparentize, tint } from 'polished'

export const EditorWrapper = styled(CodeMirror)<{ id?: string }>`
  margin: 0;
  padding: 0;
  width: 100%;

  .cm-s-idea {
    &.CodeMirror {
      height: 16.8rem;
      display: grid;
      font-family: ${(props) => props.theme.font.family.default};
      color: ${(props) => props.theme.color.textSecondary};
      line-height: 2;
      background-color: ${(props) => tint(0.96, props.theme.color.text)};
      border: 0.1rem solid ${(props) => props.theme.color.inputColor};
      border-radius: 0.8rem;
      box-shadow: none;
      transition: color 0.26s ease, box-shadow 0.26s ease;
      z-index: ${(props) => props.theme.zIndex.minimal};
      &-focused {
        caret-color: ${(props) => props.theme.color.black};
        outline: none;
      }
      pre {
        padding: 0 1.2rem;
        font-size: 1.4rem;
      }
    }
    div.CodeMirror-selected {
      background: ${(props) => transparentize(0.92, props.theme.color.black)};
    }

    .CodeMirror-placeholder {
      color: ${(props) => props.theme.color.default};
    }
    .CodeMirror-scroll {
      min-height: 16.8rem;
    }
    .CodeMirror-line::selection,
    .CodeMirror-line > span::selection,
    .CodeMirror-line > span > span::selection {
      background: ${(props) => transparentize(0.8, props.theme.color.black)};
    }
    .CodeMirror-gutters {
      background: ${(props) => tint(0.8, props.theme.color.elementBorderSecond)};
      border-right: 0.1rem solid ${(props) => props.theme.color.elementBorderSecond};
    }
    .CodeMirror-guttermarker {
      color: ${(props) => props.theme.color.black};
    }
    .CodeMirror-guttermarker-subtle {
      color: #3e7087;
    }
    .CodeMirror-linenumber {
      min-width: 2.3rem;
      text-align: center;
      color: ${(props) => props.theme.color.textThird};
    }
    .CodeMirror-cursor {
      border-left: 0.15rem solid ${(props) => props.theme.color.textHint};
    }
    .CodeMirror-scrollbar-filler,
    .CodeMirror-gutter-filler {
      background-color: ${(props) => transparentize(0.8, props.theme.color.black)};
    }

    span.cm-comment {
      color: ${(props) => props.theme.color.textHint};
      font-style: ${(props) => props.theme.font.style.italic};
      line-height: 1em;
    }
    span.cm-atom {
      color: #f4c20b;
    }
    span.cm-number,
    span.cm-attribute {
      color: #82c6e0;
    }
    span.cm-keyword {
      color: #f0f;
    }
    span.cm-string {
      color: #f08047;
    }
    span.cm-meta {
      color: #f0f;
    }
    span.cm-variable-2,
    span.cm-tag {
      color: #7bd827;
    }
    span.cm-variable-3,
    span.cm-def,
    span.cm-type {
      color: ${(props) => props.theme.color.black};
    }
    span.cm-bracket {
      color: #f0f;
    }
    span.cm-link {
      color: #f4c20b;
    }
    span.CodeMirror-matchingbracket {
      color: #f0f !important;
    }
    span.cm-builtin,
    span.cm-special {
      color: #ff9d00;
    }
    span.cm-error {
      color: ${(props) => props.theme.color.danger};
    }

    .CodeMirror-activeline-background {
      background: ${(props) => props.theme.color.success};
    }
    .CodeMirror-vscrollbar,
    .CodeMirror-hscrollbar {
      outline: none;
    }
    .CodeMirror-vscrollbar {
      scrollbar-width: thin;
      ::-webkit-scrollbar {
        width: 1em;
      }
      ::-webkit-scrollbar:vertical {
        width: 1em;
      }
      ::-webkit-scrollbar-track {
        background-color: ${(props) => tint(0.96, props.theme.color.text)};
        border-top: none;
        border-bottom: none;
        border-left: 0.1rem solid ${(props) => props.theme.color.inputColor};
      }
      ::-webkit-scrollbar-thumb {
        background-color: ${(props) => props.theme.color.scrollbarColor};
      }
    }
    .CodeMirror-hscrollbar {
      scrollbar-width: thin;

      ::-webkit-scrollbar {
        width: 1em;
      }
      ::-webkit-scrollbar:horizontal {
        width: 1em;
      }
      ::-webkit-scrollbar-track {
        background-color: ${(props) => tint(0.96, props.theme.color.text)};
        border-left: none;
        border-top: 0.1rem solid ${(props) => props.theme.color.inputColor};
      }
      ::-webkit-scrollbar-thumb {
        background-color: ${(props) => props.theme.color.scrollbarColor};
      }
    }
    .CodeMirror-scrollbar-filler {
      background: ${(props) => tint(0.8, props.theme.color.elementBorderSecond)};
      border-top: 0.1rem solid ${(props) => props.theme.color.inputColor};
      border-left: 0.1rem solid ${(props) => props.theme.color.inputColor};
    }
  }

  .error {
    color: ${(props) => props.theme.color.danger};
    .cm-s-idea .CodeMirror {
      border-color: ${(props) => props.theme.color.danger};
    }
  }
`
